import { render, staticRenderFns } from "./MbtiTest.vue?vue&type=template&id=2e36fcca&scoped=true"
import script from "./MbtiTest.vue?vue&type=script&lang=js"
export * from "./MbtiTest.vue?vue&type=script&lang=js"
import style0 from "./MbtiTest.vue?vue&type=style&index=0&id=2e36fcca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e36fcca",
  null
  
)

export default component.exports